module.exports = __webpack_public_path__ + "static/media/MenuLight.a94f0c1d.svg";